import React from 'react';
import { StyledHiddenHeading3 } from '../Footer.styles';
import {
    StyledSmallPrint,
    StyledSmallPrintLayout,
    List,
    ListItem,
    StyledLink,
    Text
} from './SmallPrintSection.styles';

const getCurrentYear = () => {
    return ` ${new Date().getFullYear()}`;
};

function SmallPrintSection() {
    return (
        <StyledSmallPrint>
            <StyledHiddenHeading3>
                Legal and corporate information
            </StyledHiddenHeading3>
            <List>
                <ListItem>
                    <StyledLink
                        href="/property/estimate/about/"
                        data-track-category="footer"
                        data-track-action="clickthrough"
                        data-track-label="zoopla estimates"
                    >
                        Zoopla estimates
                    </StyledLink>
                </ListItem>
                <ListItem>
                    <StyledLink
                        href="/property/streets/"
                        data-track-category="footer"
                        data-track-action="clickthrough"
                        data-track-label="street index"
                    >
                        Street index
                    </StyledLink>
                </ListItem>
                <ListItem>
                    <StyledLink
                        href="/sitemap/popular-areas/"
                        data-track-category="footer"
                        data-track-action="clickthrough"
                        data-track-label="popular areas"
                    >
                        Popular areas
                    </StyledLink>
                </ListItem>
                <ListItem>
                    <p>
                        © {getCurrentYear()} Zoopla Limited. All rights
                        reserved.
                    </p>
                </ListItem>
            </List>
            <>
                <Text>
                    Sold house prices provided by Land Registry/Registers of
                    Scotland. © Crown copyright
                    {getCurrentYear()}.
                </Text>
                <StyledSmallPrintLayout>
                    <div>
                        <Text>
                            Our website is completely free for you to use but we
                            may receive a commission from some of the companies
                            we link to on the site.
                        </Text>
                        <Text>
                            *Zoopla Limited is an appointed representative of
                            Uswitch Limited which is authorised and regulated by
                            the Financial Conduct Authority (FRN 312850) to
                            provide this mortgage comparison service.
                        </Text>
                    </div>
                    <div>
                        <Text>
                            **Uswitch Limited is authorised and regulated by the
                            Financial Conduct Authority (FCA) under firm
                            reference number 312850.
                        </Text>
                    </div>
                </StyledSmallPrintLayout>
            </>
        </StyledSmallPrint>
    );
}

export default SmallPrintSection;
